"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _renderProps = require("../../libs/renderProps");

var _Loader = _interopRequireDefault(require("@insided/shared/uikit/Loader"));

var ItemList = function ItemList(_ref) {
  var loading = _ref.loading,
      items = _ref.items,
      getMenuProps = _ref.getMenuProps,
      getItemProps = _ref.getItemProps,
      highlightedIndex = _ref.highlightedIndex,
      children = _ref.children;

  if (loading) {
    return (0, _preact.h)("div", {
      className: "control-dropdown"
    }, (0, _preact.h)("div", {
      className: "control-dropdown__list"
    }, (0, _preact.h)("div", {
      className: "loader"
    }, (0, _preact.h)(_Loader.default, null))));
  }

  if (items.length > 0) {
    return (0, _preact.h)("div", {
      className: "control-dropdown"
    }, (0, _preact.h)("div", getMenuProps({
      class: 'control-dropdown__list'
    }), items.map(function (item, index) {
      var _item$disabled;

      return (0, _preact.h)("a", (0, _extends2.default)({
        key: index
      }, getItemProps({
        index: index,
        item: items[index],
        class: "selector-item ".concat(highlightedIndex === index ? 'active' : '', " qa-selector-item")
      }), {
        disabled: (_item$disabled = item.disabled) !== null && _item$disabled !== void 0 ? _item$disabled : false
      }), (0, _renderProps.extractRenderPropsChildren)(children)(item));
    })));
  }

  return null;
};

var _default = ItemList;
exports.default = _default;